import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import MediaPickerLoadMoreCard from '../../../common/MediaPickerLoadMoreCard';
import MediaPickersConstants from '../../../MediaPickersConstants';

const BackgroundStockImagesLoadMoreCard = (props) => {
    const { 
        setProperty, backgroundStockImagesOrientation, searchBackgroundStockImages, backgroundStockImagesSearchValue, backgroundStockImagesDefaultKeyword, backgroundStockImagesLoading, 
        galleryCardWidth, galleryCardHeight, backgroundStockImagesPageNumber
    } = props;
    
    const onLoadMoreButtonClick = () => {
        setProperty('backgroundStockImagesLoading', true);
        const keyword = backgroundStockImagesSearchValue || backgroundStockImagesDefaultKeyword;
        searchBackgroundStockImages(keyword, backgroundStockImagesOrientation, backgroundStockImagesPageNumber + 1, MediaPickersConstants.BACKGROUND_STOCK_IMAGES_PER_PAGE, () => {
            setProperty('backgroundStockImagesLoading', false);
        });
    }

    return (
        <MediaPickerLoadMoreCard
            key={'load-more-button'}
            onLoadMoreButtonClick={onLoadMoreButtonClick}
            isLoading={backgroundStockImagesLoading}
            galleryCardWidth={galleryCardWidth}
            galleryCardHeight={galleryCardHeight}
        />
    );
};

const mapStateToProps = (state) => {
    const { 
        backgroundStockImagesOrientation,
        backgroundStockImagesSearchValue, 
        backgroundStockImagesDefaultKeyword,
        backgroundStockImagesLoading,
        backgroundStockImagesPageNumber
    } = state.mediaPicker;

    return { 
        backgroundStockImagesOrientation,
        backgroundStockImagesSearchValue,
        backgroundStockImagesDefaultKeyword,
        backgroundStockImagesLoading,
        backgroundStockImagesPageNumber
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const searchBackgroundStockImages = (keywords, orientation, pageNumber, itemsPerPage, callback) => dispatch(mediaPickerActions.searchBackgroundStockImages(keywords, orientation, pageNumber, itemsPerPage, callback));

    return { 
        setProperty,
        searchBackgroundStockImages 
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundStockImagesLoadMoreCard);